import { GoogleAnalyticsEventsType } from '@nw/shared/config';

import { SegmentEvent } from '../../../../..//shared/stores/models/SegmentEvent';

import { FormConfigDTO } from '../../../dtos/forms.dtos';

import DependentFormInfo from '../DependentFormInfo';

class FormConfig {
  title: string;
  instructionsText!: string | undefined;
  submitButtonId!: string | undefined;
  segmentEventTypes: Record<string, SegmentEvent> | undefined;
  shouldSendSegmentEvent!: boolean | undefined;
  dependentFormInfo!: DependentFormInfo | undefined;
  queryParamKey!: string | undefined;
  formSubmissionType!: string | undefined;
  googleAnalyticsEvents: GoogleAnalyticsEventsType | undefined;
  enablePostMessage!: boolean;
  enableOtpAutofill!: boolean;

  constructor(formConfig: FormConfigDTO) {
    const {
      title,
      instructionsText,
      submitButtonId,
      segmentEventTypes,
      shouldSendSegmentEvent,
      dependentFormInfo,
      queryParamKey,
      googleAnalyticsEvents,
      enablePostMessage,
      enableOtpAutofill
    } = formConfig;
    this.title = title;
    this.googleAnalyticsEvents = googleAnalyticsEvents;
    this.enablePostMessage = enablePostMessage ?? false;
    this.enableOtpAutofill = enableOtpAutofill ?? false;
    if (instructionsText) this.instructionsText = instructionsText;
    if (submitButtonId) this.submitButtonId = submitButtonId;
    if (shouldSendSegmentEvent)
      this.shouldSendSegmentEvent = shouldSendSegmentEvent;
    if (dependentFormInfo)
      this.dependentFormInfo = new DependentFormInfo(dependentFormInfo);
    if (queryParamKey) this.queryParamKey = queryParamKey;
    if (segmentEventTypes) {
      Object.keys(segmentEventTypes).forEach((key) => {
        if (this.segmentEventTypes && segmentEventTypes[key]) {
          this.segmentEventTypes[key] = new SegmentEvent(
            segmentEventTypes[key]
          );
        } else {
          this.segmentEventTypes = {};
          this.segmentEventTypes[key] = new SegmentEvent(
            segmentEventTypes[key]
          );
        }
      });
    }
  }
}

export default FormConfig;
